import React from 'react';
import { Button, Collapse, Container, UncontrolledDropdown, Nav, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, DropdownItem, DropdownToggle, DropdownMenu, } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import { useAuth } from '../Services/AuthContext';
import { useEffect } from 'react';
import Logo from './Cards/Logo';
import { logout } from '../utils/Hooks/useLocalStorage';
import { useAlert } from '../Services/AlertContext';

const LoggedIn = () => {
   
    const [user] = useAuth();

    return <DropdownItem style={{ backgroundColor: '#036caa', color: 'white', padding: '15px' }}>
        <div>{user ? user.role : ""}</div>
        <div>{user ? user.email : ""}</div>
     
    </DropdownItem>

}
const Version = () => {
    const { REACT_APP_VERSION, REACT_APP_NAME } = process.env;
    const [auth] = useAuth();
    const alert = useAlert(); 
    const refreshCacheAndReload= () => {
        console.log('Clearing cache and hard reloading...')
        if (caches) {
            // Service worker cache should be cleared with caches.delete()
            caches.keys().then(function (names) {
                for (let name of names) caches.delete(name);
            });
        }

        // delete browser cache and hard reload
        window.location.reload(true);
    }
    const newVersion = auth.serverVersion && auth.serverVersion.substring(0, REACT_APP_VERSION.length) !== REACT_APP_VERSION;
    if (newVersion) {
        alert({
            title: <h1>New Version</h1>, body: <div>
                <h2>There is a new version of JetBidders ({auth.serverVersion}).</h2>
                <h5>Your Version is ({REACT_APP_VERSION}).</h5>
            </div>, buttons: <Button onClick={refreshCacheAndReload}>Refresh</Button>
        })
    }
    return<React.Fragment> <DropdownItem style={{ backgroundColor: '#036caa', color: 'white', padding: '15px' }}>
        <div style={{ fontSize: 'smaller' }} >{REACT_APP_NAME} - version: {REACT_APP_VERSION}</div>
        <div style={{ fontSize: 'smaller' }} >Server version: {auth.serverVersion}</div>
        
        <div style={{ fontSize: '5px' }}>React version: {React.version}</div>
    </DropdownItem>

        {newVersion ? <Button onClick={refreshCacheAndReload}>Reload</Button> : null}
    </React.Fragment>
}
const Privacy = () => <div style={{ padding: '15px' }}>
    <div >
    Copyright Avmin {new Date().getFullYear()}
                    </div>
        <div>
        All&nbsp;rights&nbsp;reserved
        </div>
        <div>
            <a href='https://www.avmin.com.au/privacy-policy'>Our Privacy Policy</a>
    </div>
    <div>
        Contact: <a href='tel::1300286462'>1300 286 462</a>
    </div>

</div>
const LogOut = () => {
    const [, dispatch] = useAuth();
    
    const logoutClick = () => {
        dispatch({ type: "removeAuthDetails" });
        logout();
      
    }
    return <DropdownItem style={{ borderTop: 'solid', padding: 0, borderWidth: 2, borderColor: '#036caa' }}>
        <NavLink tag={Link} onClick={logoutClick} className="text-dark" to="#">Logout</NavLink>
    </DropdownItem>
}
const CharterAdminNav = () => {
    return <React.Fragment>
        <NavItem>
            <NavLink tag={Link} className="text-dark" to="/charterRequests/Me/Live">Charter Requests</NavLink>
        </NavItem>
        <NavItem>
            <NavLink tag={Link} className="text-dark" to="/charterShares/Me/Live">Charter Shares</NavLink>
        </NavItem>
    </React.Fragment>
}

const AdminNav = () => {
    return <React.Fragment>
        <NavItem>
            <NavLink tag={Link} className="text-dark" to="/manageAdmins">Admins</NavLink>
        </NavItem>
        {false ? <NavItem>
            <NavLink tag={Link} className="text-dark" to="/manageCharterAdmins">CharterAdmins</NavLink>
        </NavItem> : null}
        <NavItem>
            <NavLink tag={Link} className="text-dark" to="/manageSuppliers">Suppliers</NavLink>
        </NavItem>
        <NavItem>
            <NavLink tag={Link} className="text-dark" to="/manageClients/Clients">Clients</NavLink>
        </NavItem>
        <NavItem>
            <NavLink tag={Link} className="text-dark" to="/charterRequests/Me/Live">Charter Requests</NavLink>
        </NavItem>
        <NavItem>
            <NavLink tag={Link} className="text-dark" to="/charterShares/Me/Live">Charter Shares</NavLink>
        </NavItem>
     
       
    </React.Fragment>
}

const NavMenu = ({ heightChanged }) => {
    const [collapsed, setCollapsed] = React.useState(true);
    const [auth] = useAuth();
    const toggleNavbar = () => {
        setCollapsed(!collapsed)
    }


    useEffect(() => {
        heightChanged && heightChanged(collapsed);
    }, [collapsed,heightChanged])



    const SupplierNav = ({ qGov }) => <React.Fragment>


        <NavItem>
            <NavLink tag={Link} className="text-dark" to="/charterRequests/Me/Live">Live Charters</NavLink>
        </NavItem>
        <NavItem>
            <NavLink tag={Link} className="text-dark" to="/aircraft">Aircraft</NavLink>
        </NavItem>
        <NavItem>
            <NavLink tag={Link} className="text-dark" to="/documents">Operator Documents</NavLink>
        </NavItem>
       {qGov ? <NavItem>
            <NavLink tag={Link} className="text-dark" to="/insuranceDocuments">Insurance Documents</NavLink>
        </NavItem> : null}
        <NavItem>
            <NavLink tag={Link} className="text-dark" to="/bids">My Past Bids</NavLink>
        </NavItem>

    </React.Fragment>;
    const ClientNav = ({ client, clientDepartment, qGov }) => <React.Fragment>


        <NavItem>
            <NavLink tag={Link} className="text-dark" to="/CharterRequests/Me/Live">Charters</NavLink>
        </NavItem>
        {client ? <NavItem>
            <NavLink tag={Link} className="text-dark" to="/manageDepartments">Departments</NavLink>
        </NavItem> : null}
        {client  ? <NavItem>
            <NavLink tag={Link} className="text-dark" to="/manageStaff">Staff</NavLink>
        </NavItem> : null}

        {qGov ? <NavItem>
            <NavLink tag={Link} className="text-dark" to="/CharterShares/Me/Live">Charter Shares</NavLink>
        </NavItem> : null}
      
    </React.Fragment>


    return auth && auth.jwt ? <header >
        <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow" light>
            <Container>

                <NavbarBrand tag={Link} to="/charterRequests/Me/Live" style={{ height: '80px' }}>
                    <Logo size={100} style={{ marginTop: '-10px' }} />
                </NavbarBrand>
                <NavbarToggler onClick={toggleNavbar} className="mr-2" />
                <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!collapsed} navbar>
                    <Nav>
                        {auth.role === "Supplier" ? <SupplierNav qGov={auth.qGov} /> : null}
                        {auth.role === "Admin" ? <AdminNav /> : null}
                        {auth.role === "Client" ? <ClientNav qGov={auth.qGov} client /> : null}
                        {auth.role === "ClientDepartment" ? <ClientNav qGov={auth.qGov} clientDepartment /> : null}
                        {auth.role === "ClientStaff" ? <ClientNav qGov={auth.qGov} /> : null}
                        {auth.role === "CharterAdmin" ? <CharterAdminNav qGov={auth.qGov} /> : null}

                    </Nav>
                </Collapse>
                

                {auth.role !== "Supplier"? <NavLink tag={Link} className="text-dark" to="/newCharterRequest"><Button color='primary'>New Charter Request
               </Button></NavLink>
                :null}
               
                <div style={{ marginLeft: 'auto' }}>
                        <UncontrolledDropdown>
                            <DropdownToggle nav caret className="text-dark">My Account</DropdownToggle>
                        <DropdownMenu style={{ padding: 0, borderWidth: 2, borderColor: '#036caa', right: 0, left: 'auto'}}>
                                <LoggedIn />
                                <DropdownItem style={{ padding: 0, borderWidth: 2, borderColor: 'blue' }}>

                                    <NavLink tag={Link} className="text-dark" to="/messageLog">Messages</NavLink>

                                </DropdownItem>
                                {auth.managesWorkflow ? <DropdownItem style={{ padding: 0, borderWidth: 2, borderColor: 'blue' }}>
                                    <NavLink tag={Link} className="text-dark" to="/manageWorkflow">Manage Workflows</NavLink>
                                </DropdownItem> : null}
                                {auth.managesMessages ? <DropdownItem style={{ padding: 0, borderWidth: 2, borderColor: 'blue' }}>
                                    <NavLink tag={Link} className="text-dark" to="/manageMessaging">Manage Messaging</NavLink>
                                </DropdownItem> : null}
                                <DropdownItem style={{ borderTop: 'solid', padding: 0, borderWidth: 2, borderColor: 'blue' }}>


                                    <NavLink tag={Link} className="text-dark" to="/me">My Details</NavLink>

                                </DropdownItem>
                                <LogOut />
                            <Version />
                            <Privacy />
                            </DropdownMenu>
                        </UncontrolledDropdown>
     
                </div>

            </Container>
        </Navbar>
    </header> : null
}
export default NavMenu;